import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "antd";

const PWAUpdateBanner = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        background: "#0A7CA5",
        color: "#fff",
        padding: "12px 20px",
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        gap: 12,
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        whiteSpace: "nowrap",
      }}
    >
      <span>Nueva versión disponible.</span>
      <Button
        size="small"
        onClick={() => updateServiceWorker(true)}
        style={{ background: "#fff", color: "#0A7CA5", border: "none", fontWeight: 700 }}
      >
        Actualizar
      </Button>
    </div>
  );
};

export default PWAUpdateBanner;
